<template>
	<div class="con">
		<div class="header">
			<h1>{{ ksmc }}</h1>
			<p>请选择就诊日期和医生</p>
		</div>
		
		<!--日历-->
		<div class="calendar">
			<div class="date">
				<!-- 年份 月份 -->
				<div class="month">
					<div class="week-nav">
						<div class="week-btn" @click="weekPre">
							&lt;
						</div>
						<div class="month-center">{{ currentYear }}年{{ currentMonth }}月{{ currentDay }}日</div>
						<div class="week-btn" @click="weekNext">
							&gt;
						</div>
					</div>
				</div>
				<!-- 星期 -->
				<ul class="weekdays">
			        <li>一</li>
			        <li>二</li>
			        <li>三</li>
			        <li>四</li>
			        <li>五</li>
			        <li>六</li>
			        <li>日</li>
			      </ul>
				<!-- 日期 -->
				<ul class="days">
					<li @click="pick(day)" v-for="(day, index) in days" :key="index">
						<span :class="[day.getDate() == currentDay ? 'active':'', isToday(day) ? 'today': '']">{{ day.getDate() }}</span>
					</li>
				</ul>
			</div>
		</div>
		
		<div class="list" v-if="list.length != ''">
			<div class="doctor-list">
				<div class="list-text" v-for="(item,index) in list" :key="'doc'+index" @click="doctorBtn(index)">
					<img class="list-left-img" src="../assets/doctor.png" />
					<div class="lis-right">
						<div class="list-right-name">
							<div class="text">{{item.YSXM}}</div>
							<div class="list-right-have" v-if="item.TOTAL>0" >余号:{{item.TOTAL}}</div>
							<div class="list-right-no" v-else>无号源</div>
						</div>
						<div class="level-flex">
							<div class="level">{{item.JBMC}}</div>
							<div class="noon">{{item.ZBLB == 1 ? '上午' : '下午'}}</div>
						</div>
						<div class="goodAt">{{item.goodAt}}</div>
						<!--擅长-->
					</div>
				</div>
			</div>
		</div>
		
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">今日无值班医生</div>
			<div class="no-subtext">请选择其他日期</div>
		</div>
		
		<div class="loading" v-if="loading">
			<van-loading type="spinner" color="#27BEC4" />
			<div class="loading-text">加载医生信息中...</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'registeredDeta',
		data() {
			return {
				msg: '挂号预约详情',
				ksmc: '', //科室名称
				ksdm: '', //科室id
				list: [],
				currentYear: 1970, // 年份
				currentMonth: 1, // 月份
				currentDay: 1, // 日期
				currentWeek: 1, // 星期
				days: [], //7天的日历
				noImgShow: false,
				loading: false,
			}
		},
		methods: {
			// 检查是否为今天
			isToday(date) {
				const today = new Date();
				return date.getFullYear() === today.getFullYear() && 
					date.getMonth() === today.getMonth() && 
					date.getDate() === today.getDate();
			},

			//点击医生列表
			doctorBtn(e) {
				let list = this.list[e];
				if(list.TOTAL<=0){
					return
				}
				list.ksdm = this.ksdm;
				list.ksmc = this.ksmc;
				let currentMonth = this.currentMonth;

				list.chooseTime = this.currentYear + '-' + this.timeformat(this.currentMonth) + '-' + this.timeformat(this.currentDay);
				this.$store.commit('dUser', list)
				
				this.$router.push({
					path: '/regConfirmation',
					
				})
			},
			timeformat(x) {
				if(x <= 9) {
					return '0' + x;
				}
				return x;
			},
			/*获取医生
			 * 
			 * CZLX  0 普通  1 专家
			 * jbmc 级别名称
			 * ygdm 医生编码
				ygjb 级别编码 
				ZBLX 值班类型，通过这个值获取 医生值班时间
			 * */
			GetMsYszb() {
				this.loading = true;

				let day = this.currentYear + '-' + this.currentMonth + '-' + this.currentDay;
				
				// this.$Axios.Get('/msYszbHis6?ksdm=' + this.ksdm + '&zbrq=2019-05-21', null).then(data => {
				this.$Axios.Get('/outpatient/msYszb?ksdm=' + this.ksdm + '&zbrq=' + day, null).then(data => {
					this.loading = false;
					console.log(data)
					if(data.code == 0) {
						if(data.msg.length != 0) {
							this.noImgShow = false;
							this.list = data.msg;
						} else {
							this.noImgShow = true;
							this.list = [];
						}

					} else {
						this.list = [];
						this.noImgShow = true;
					}
				}).catch(err => {
					this.noImgShow = true;
					this.loading = false;
					this.list = [];
					console.log(err)
				})
			},
			formatDate(year, month, day) {
				const y = year
				let m = month
				if(m < 10) m = `0${m}`
				let d = day
				if(d < 10) d = `0${d}`
				return `${y}-${m}-${d}`
			},

			initData(cur) {
				let date = '';
				if(cur) {
					date = new Date(cur)
				} else {
					date = new Date()
				}
				this.currentDay = date.getDate() // 今日日期 几号
				this.currentYear = date.getFullYear() // 当前年份
				this.currentMonth = date.getMonth() + 1 // 当前月份
				this.currentWeek = date.getDay() // 1...6,0   // 星期几
				if(this.currentWeek === 0) {
					this.currentWeek = 7
				}
				const str = this.formatDate(this.currentYear, this.currentMonth, this.currentDay) // 今日日期 年-月-日
				this.days.length = 0
				// 今天是周日，放在第一行第7个位置，前面6个 这里默认显示一周，如果需要显示一个月，则第二个循环为 i<= 35- this.currentWeek
				/* eslint-disabled */
				for(let i = this.currentWeek - 1; i >= 0; i -= 1) {
					const d = new Date(str)
					d.setDate(d.getDate() - i)
					this.days.push(d)
				}
				for(let i = 1; i <= 14 - this.currentWeek; i += 1) {
					const d = new Date(str)
					d.setDate(d.getDate() + i)
					this.days.push(d)
				}
			},

			//  上个星期
			weekPre() {
				const d = this.days[0] // 如果当期日期是7号或者小于7号
				d.setDate(d.getDate() - 7)
				this.initData(d)
			},

			//  下个星期
			weekNext() {
				const d = this.days[6] // 如果当期日期是7号或者小于7号
				d.setDate(d.getDate() + 7)
				this.initData(d)
			},

			// 上一個月   传入当前年份和月份
			pickPre(year, month) {
				const d = new Date(this.formatDate(year, month, 1))
				d.setDate(0)
				this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1))
			},

			// 下一個月   传入当前年份和月份
			pickNext(year, month) {
				const d = new Date(this.formatDate(year, month, 1))
				d.setDate(35)
				this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1))
			},

			// 当前选择日期
			pick(date) {
				this.noImgShow = false;
				this.currentYear = date.getFullYear();
				this.currentMonth = date.getMonth() + 1;
				this.currentDay = date.getDate();
				this.GetMsYszb();
			}
		},
		mounted() {
			this.ksdm = this.$route.query.ksdm;
			this.ksmc = this.$route.query.ksmc;
			this.GetMsYszb();
			// this.GetYszbjJb();
		},
		created() {
			this.initData(null)
		},
	}
</script>

<style scoped>
	/* 全局样式 */
	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
		background-color: #f5f7fa;
	}
	
	/* 头部样式 */
	.header {
		padding: 16px;
		background-color: #fff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
		margin-bottom: 12px;
	}
	
	.header h1 {
		font-size: 18px;
		font-weight: 600;
		color: #333;
		margin-bottom: 6px;
	}
	
	.header p {
		font-size: 14px;
		color: #999;
		margin: 0;
	}
	
	/* 日历样式 */
	.calendar {
		background-color: #fff;
		border-radius: 12px;
		margin: 0 16px 16px;
		padding: 16px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	}
	
	.date {
		width: 100%;
	}
	
	.month {
		padding: 10px 0;
		text-align: center;
		font-size: 16px;
		color: #333;
		font-weight: 500;
		margin-bottom: 12px;
	}
	
	.weekdays {
		display: flex;
		justify-content: space-around;
		font-size: 14px;
		color: #666;
		margin-bottom: 12px;
		padding-bottom: 8px;
		border-bottom: 1px solid #f0f0f0;
	}
	
	.weekdays li {
		width: 14%;
		text-align: center;
	}
	
	.days {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		padding: 8px 0;
		font-size: 14px;
	}
	
	.days li {
		line-height: 36px;
		width: 14%;
		text-align: center;
		margin-bottom: 8px;
		transition: all 0.3s ease;
	}
	
	.days li:hover {
		transform: scale(1.05);
	}
	
	.days li>span {
		text-align: center;
		transition: all 0.3s ease;
	}
	
	.active {
		display: inline-block;
		width: 36px;
		height: 36px;
		line-height: 36px;
		border-radius: 50%;
		background-color: #27BEC4;
		color: #fff;
		font-weight: 500;
	}
	
	.today {
		color: #27BEC4;
		font-weight: 500;
	}
	
	/* 医生列表样式 */
	.list {
		flex: 1;
		overflow-y: scroll;
		padding: 0 16px 16px;
	}
	
	.doctor-list {
		width: 100%;
	}
	
	.list-text {
		display: flex;
		align-items: center;
		padding: 16px;
		font-size: 15px;
		background-color: #fff;
		border-radius: 12px;
		margin-bottom: 12px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
		transition: all 0.3s ease;
		cursor: pointer;
	}
	
	.list-text:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
	}
	
	.list-left-img {
		width: 70px;
		height: 70px;
		border-radius: 8px;
		margin-right: 16px;
		object-fit: cover;
	}
	
	.lis-right {
		flex: 1;
		min-width: 0;
	}
	
	.list-right-name {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 8px;
	}
	
	.list-right-name .text {
		font-size: 16px;
		font-weight: 600;
		color: #333;
	}
	
	.list-right-have {
		padding: 4px 12px;
		font-size: 12px;
		background-color: #27BEC4;
		color: #FFFFFF;
		border-radius: 12px;
		font-weight: 500;
	}
	
	.list-right-no {
		padding: 4px 12px;
		font-size: 12px;
		background-color: #f0f0f0;
		color: #999;
		border-radius: 12px;
	}
	
	.level-flex {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 8px;
	}
	
	.level {
		font-size: 14px;
		color: #666;
	}
	
	.noon {
		color: #999;
		font-size: 13px;
		padding: 2px 8px;
		background-color: #f5f7fa;
		border-radius: 8px;
	}
	
	.goodAt {
		font-size: 13px;
		color: #999;
		line-height: 1.4;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	/* 无数据样式 */
	.noImg {
		margin-top: 3vh;
		text-align: center;
		padding: 0 16px;
	}
	
	.noImg img {
		width: 120px;
		height: 120px;
		margin-bottom: 16px;
	}
	
	.no-text {
		font-size: 16px;
		color: #333;
		margin-bottom: 8px;
		font-weight: 500;
	}
	
	.no-subtext {
		font-size: 14px;
		color: #999;
	}
	
	/* 加载状态 */
	.loading {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: rgba(255, 255, 255, 0.9);
		padding: 20px;
		border-radius: 12px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		text-align: center;
		z-index: 9999;
	}
	
	.loading-text {
		margin-top: 12px;
		font-size: 14px;
		color: #666;
	}
	
	/* 周切换按钮 */
	.week-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 16px;
	}
	
	.week-btn {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background-color: #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		color: #666;
		transition: all 0.3s ease;
		cursor: pointer;
	}
	
	.week-btn:hover {
		background-color: #e0e0e0;
		transform: scale(1.1);
	}
	
	.month-center {
		font-size: 16px;
		font-weight: 500;
		color: #333;
	}
</style>